export default __webpack_public_path__ + "static/b-user-testing-screen-4-5d662f806deb0dfa1fe41e015c38e1d6.jpg";